<ng-container *ngIf="show">
  <div class="overlay-asset">
    <mat-spinner class="spinner-asset"></mat-spinner>
  </div>
</ng-container>
